import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import jwt_decode from "jwt-decode";
import { authProject } from "utils";
import { authConfig } from "../../utils/auth";

import * as Yup from "yup";
import { schema, schemaFields } from "./schemaPersonal";

import { message } from "antd";

import FormPersonal from "./FormPersonal";
import FormAddress from "./FormAddress";
import FormSecurity from "./FormSecurity";
import FormPlans from "./FormPlans";
import FormPayment from "./FormPayment";

import Steps from "../../components/Steps";

import { normalizeText, removeMask } from "../../utils/removeMask";

import { useParams } from "react-router-dom";

import { routeProps as personalRouteProps } from "./schemaPersonal";

import {
  createAccountShort,
  getEmailUser,
  getTaxIdUser,
  getPhoneUser,
  getPaymentGroup,
  getItem,
  setItem,
  removeItem,
  checkIndicationCode,
} from "utils";

import ModalTokenConfirm from "../../components/Modal/TokenConfirm";
import ModalSuccessSignUp from "../../components/Modal/SuccessSignUp";

import "./styles.css";

import { dtoOnboarding } from "./dtoOnboarding";

const scrollToRef = (ref) => ref.current.scrollTo(0, ref.current);

function Signup({ skipPayment }) {
  const { paymentGroupId, type, currentUserId, formStep } = useParams();
  const enumTypeConfirmation = { tokenEmail: "1", tokenPhone: "2" };

  const [step, setStep] = useState(currentUserId ? 3 : 0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const formContainer = useRef(null);
  const [selectedPlan, setSelectedPlan] = useState("");
  const companyName = getItem("companyName");
  const [routeProps, setRouteProps] = useState(personalRouteProps);

  const {
    register,
    handleSubmit,
    control,
    getValues,
    setValue,
    clearErrors,
    watch,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    mode: "all",
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    async function getPreFilled() {
      const val = await getItem("preFilled");
      reset({ ...val });
    }

    setTimeout(() => {
      getPreFilled();
    }, 200);
  }, []);

  useEffect(() => {

    const val = getItem("preFilled")
    const hasVal = val ? `?${new URLSearchParams(val).toString()}` : "";



    if (currentUserId) {
      window.history.replaceState(
        null,
        "",
        type
          ? `/auth/personal/plans/${currentUserId}/${paymentGroupId}/${routeProps[step]?.route}${hasVal}`
          : `/auth/plans/${currentUserId}/${paymentGroupId}/${routeProps[step]?.route}${hasVal}`
      );
    } else {
      window.history.replaceState(
        null,
        "",
        type
          ? `/auth/personal/signup/${paymentGroupId}/${routeProps[step]?.route}${hasVal}`
          : `/auth/signup/${paymentGroupId}/${routeProps[step]?.route}${hasVal}`
      );
    }

    const event = new Event("historyChange");
    window.dispatchEvent(event);

    document.title = `${companyName} : Cadastro - ${routeProps[step]?.name}`;
  }, [step]);

  const changeStep = async (value) => {
    if (value !== step) {
      // const valid = await validateStep();
      scrollToRef(formContainer);
      window.scrollTo(0, 0);
      window.scrollTo({ top: 0, behavior: "smooth" });
      // if (valid === false) return false;

      const length = Object.keys(routeProps).length;
      setStep(value < 0 ? 0 : value > length ? length : value);
    }
  };

  async function validateStep() {
    const values = getValues();

    const sc = schemaFields[routeProps[step]?.route];
    const stepSchema = Yup.object().shape(sc);
    let valid = false;
    let validBackFields = false;

    try {
      await stepSchema.validate(values, { abortEarly: false });
      valid = true;
      validBackFields = await validateBackFields();
    } catch (error) {
      const errorsYup = {};

      if (error instanceof Yup.ValidationError) {
        error.inner.forEach((err) => {
          setError(err.path, { message: err.message }, { shouldFocus: true });
          errorsYup[err.path] = err.message;
        });
      }
    }

    return validBackFields && valid;
  }

  async function validateBackFields() {
    const values = getValues();
    let validBack = [];

    if (step === 0 && values.personalEmail && values.taxId && values.mobile1) {
      if (values.indication) {
        try {
          const indication = await checkIndicationCode({
            id: values.indication,
          });

          validBack.push(true);
        } catch (err) {
          setError(
            "indication",
            {
              message: "Código inválido",
            },
            { shouldFocus: true }
          );

          validBack.push(false);
        }
      }

      try {
        const taxId = await getTaxIdUser({ taxId: removeMask(values.taxId) });
        setError(
          "taxId",
          {
            message: "Este CPF já possui uma  conta",
          },
          { shouldFocus: true }
        );

        validBack.push(false);
      } catch (err) {
        validBack.push(true);
      }

      try {
        const mobile1 = "+55" + values.mobile1.replace(/\D/g, "");

        const phone = await getPhoneUser({ phone: mobile1 });
        setError(
          "mobile1",
          {
            message: "Este número já possui uma  conta",
          },
          { shouldFocus: true }
        );

        validBack.push(false);
      } catch (err) {
        validBack.push(true);
      }

      try {
        const email = await getEmailUser({
          email: String(values.personalEmail).toLowerCase(),
        });
        setError(
          "personalEmail",
          {
            message: "Este email já possui uma  conta",
          },
          { shouldFocus: true }
        );

        validBack.push(false);
      } catch (err) {
        validBack.every((i) => i) && setModalType("tokenEmail");
        validBack.push(false);
      }
    } else {
      validBack.push(true);
    }

    return validBack.every((i) => i);
  }

  async function onNext() {
    setLoading(true);

    const validSteps = await validateStep();
    setLoading(false);

    if (validSteps) {
      if (step === 2) {
        const values = getValues();
        handleCreateAccount(values, 1);
      } else if (step === 4) {
        return true;
      } else {
        changeStep(step + 1);
      }
    }
  }

  function onPrevious() {
    changeStep(step - 1);
  }

  async function handleCreateAccount(values, amountNextStep) {
    setLoading(true);

    const companyId = await getItem("companyId");
    const tk = await getItem("tk-project");

    try {
      const tkDecode = jwt_decode(tk);

      if (new Date() > new Date(tkDecode.exp * 1000)) {
        await authProject(authConfig);
      }
    } catch (err) {
      message.error(err?.response?.data?.message);
      // history.push("/auth/signin");
    }

    try {
      const data = dtoOnboarding({
        companyId,
        values,
      });

      await authProject(authConfig);

      await createAccountShort({ data })
        .then(async (res) => {
          if (res.data.data) {
            await setItem("userEmail", values.personalEmail);
            await setItem("userId", res.data.data);
            changeStep(step + amountNextStep);
          } else {
            setModalType("error");
            setErrorMessage(res?.response?.data?.message);
            setIsModalVisible(true);
          }
        })
        .catch((err) => {
          setModalType("error");
          setErrorMessage(err?.response?.data?.message);
          setIsModalVisible(true);
        });
    } catch (err) {
      message.error(err?.response?.data?.message);

      setModalType("error");
      setErrorMessage(err?.response?.data?.message);
      setIsModalVisible(true);
    }

    setLoading(false);
  }

  const formType = {
    0: FormPersonal,
    1: FormAddress,
    2: FormSecurity,
    3: FormPlans,
    4: FormPayment,
  };
  const FormType = formType[step || 0];

  return (
    <div className="__auth-background">
      <div
        className="__auth-content __auth-flex-row"
        style={step === 3 ? { paddingRight: 0 } : {}}
      >
        <div
          className="__auth-content __auth-flex-row"
          style={step === 3 ? { paddingRight: 0 } : {}}
        >
          <div className="__auth-flex-column __auth-flex-1">
            <div className="__auth-height-100 __auth-image-background"></div>
          </div>
          <div
            style={step === 3 ? { overflowX: "auto" } : {}}
            className={`__auth-flex-column __auth-flex-${
              step !== 3 ? "2" : "4"
            }`}
          >
            <div className="__auth-header">
              <div className="align-items-center">
                <div className="__auth-header-logo">
                  <div className="__auth-header-main-logo-container">
                    <div className="main-logo"></div>
                  </div>
                </div>
              </div>

              {skipPayment === null ? (
                <></>
              ) : !currentUserId ? (
                <Steps current={step}>
                  <Steps.Item title="Dados pessoais" />
                  <Steps.Item title="Endereço" />
                  <Steps.Item title="Segurança" />
                  <Steps.Item title="Planos" />
                  <Steps.Item title="Pagamento" />
                </Steps>
              ) : (
                <Steps current={step - 3}>
                  <Steps.Item title="Planos" />
                  <Steps.Item title="Pagamento" />
                </Steps>
              )}
            </div>

            <ModalTokenConfirm
              isModalVisible={
                modalType === "tokenEmail" || modalType === "tokenPhone"
              }
              setModalType={setModalType}
              type={enumTypeConfirmation[modalType]}
              userFullName={watch("fullName")}
              userPhone={watch("mobile1")}
              userEmail={watch("personalEmail")}
              changeStep={changeStep}
              taxId={watch("taxId")}
            />

            <ModalSuccessSignUp
              isModalVisible={
                isModalVisible &&
                (modalType === "success" || modalType === "error")
              }
              setIsModalVisible={setIsModalVisible}
              type={modalType}
              errorMessage={errorMessage}
            />

            {skipPayment !== null && (
              <form
                ref={formContainer}
                className="__auth-form __auth-form-signup"
                style={step === 3 ? { overflowX: "unset" } : {}}
                // onSubmit={handleSubmit(onSubmit)}
              >
                <FormType
                  setValue={setValue}
                  register={register}
                  control={control}
                  errors={errors}
                  onNext={onNext}
                  onPrevious={onPrevious}
                  loading={loading}
                  getValues={getValues}
                  setSelectedPlan={setSelectedPlan}
                  selectedPlan={selectedPlan}
                  skipPayment={skipPayment}
                />
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signup;
